var nurseslounge_myDashboard_jobsNearMe = {
    init:function($params){
        nurseslounge_myDashboard_jobsNearMe.jobs_events($params, function(){
            try{
                nurseslounge_myDashboard_jobsNearMe.jobs_search($params);
            }catch (e) {

            }
        });
        nurseslounge_myDashboard_myProfile.profile_is_complete($params, true);
    },
    jobs_events:function($params, cback){
        var $jobsUp = $("#nurseslounge-home-job-near-me .nurseslounge-home-job-near-me-up form");
        var $search = $jobsUp.find("input[name='search']")[0];
        new google.maps.places.Autocomplete($search,{
            types: ['(regions)'],
            componentRestrictions: {country: "us"}
        });
        var $employerName = $jobsUp.find('input[name="employerName"]').unbind();
        nurseslounge_myDashboard_jobsNearMe.jobs_employer_autocomplete(
            $employerName,
            $params,
            "/myDashboard/jobNearMe/mapLocations/autocomplete"
        );
        cback();
    },
    jobs_employer_autocomplete:function($target, $data, $url){
        try {
            $($target).autocomplete("destroy");
        }catch (e) {
        }
        var $value = '';
        $($target).autocomplete({
            minLength	:2,
            search		: function(){
                $(this).addClass("ui-autocomplete-loading");
            },
            open 		: function(){
                $(this).removeClass("ui-autocomplete-loading");
            },
            source: function(request, response) {
                $.ajax({
                    method: 'POST',
                    url:$url,
                    data:$.extend({
                        keyword:$($target).val()
                    }, $data),
                    dataType: "json",
                    success: function($data){
                        libs.expire($data);
                        $value = '';
                        response($data);
                    }
                });
            },
            create:function(){
                $(this).prev().remove();
                $(this).trigger("keypress.autocomplete");
            },
            select: function (event, ui) {
                $value = ui.item.value;
                $(this).val($value);
                return false;
            }
        }).keypress(function ($e) {
            if ($e.which == 13) {
                $(this).autocomplete("close");
            }
        });
    },
    jobs_search:function($params){
        var $jobsNearMe = $("#nurseslounge-home-job-near-me");
        var $jobsNearMeDown = $jobsNearMe.find(".nurseslounge-home-job-near-me-down");
        var $jobListContainer = $jobsNearMeDown.find(".jobs-list-container:first");
        var $preview = nurseslounge_myDashboard_jobsNearMe.jobs_search_list_preview();
        var $bindingResize;
        var $map = new google.maps.Map(document.getElementById('search-location-map'), {
            center: {lat: 29.8550297, lng: -97.9463043},
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            zoom: 5,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.TOP_LEFT
            },
        });
        $map.setTilt(0);
        google.maps.event.trigger($map, 'resize');
        nurseslounge_myDashboard_jobsNearMe.jobs_near_me_up_validate(function($form){
            $params = $.extend({}, $params, libs.getObjForm($form));
            $jobListContainer.html($preview).promise().done(function () {
                nurseslounge_myDashboard_jobsNearMe.jobs_near_me_request($params, function ($data) {
                    //Spotlight
                    nurseslounge_myDashboard_jobsNearMe.spotlight_container(function($container){
                        $params = $.extend({}, $params, {zip:$data.data.form.search});
                        nurseslounge_myDashboard_myProfile.spotlight($container, $params);
                    });
                    //
                    nurseslounge_myDashboard_jobsNearMe.jobs_near_me_search_map_list($params, $map, $data);
                });
            });
        });
        $jobListContainer.html($preview).promise().done(function(){
            nurseslounge_myDashboard_jobsNearMe.jobs_near_me_request($params, function ($data) {
                //Spotlight
                nurseslounge_myDashboard_jobsNearMe.spotlight_container(function($container){
                    $params = $.extend({}, $params, {zip:$data.data.form.search});
                    nurseslounge_myDashboard_myProfile.spotlight($container, $params);
                });
                //
                nurseslounge_myDashboard_jobsNearMe.jobs_near_me_search_map_list($params, $map, $data);
            });
        });
        if(!libs.isMobile()){
            $(window).unbind('resize').resize(function(){
                try{
                    clearTimeout($bindingResize);
                }catch (e) {
                }
                $bindingResize = setTimeout(function(){
                    $params = $.extend({}, $params, libs.getObjForm($("#nurseslounge-home-job-near-me .nurseslounge-home-job-near-me-up form")));
                    $jobListContainer.html($preview).promise().done(function(){
                        nurseslounge_myDashboard_jobsNearMe.jobs_near_me_request($params, function ($data) {
                            //Spotlight
                            nurseslounge_myDashboard_jobsNearMe.spotlight_container(function($container){
                                $params = $.extend({}, $params, {zip:$data.data.form.search});
                                nurseslounge_myDashboard_myProfile.spotlight($container, $params);
                            });
                            //
                            nurseslounge_myDashboard_jobsNearMe.jobs_near_me_search_map_list($params, $map, $data);
                        });
                    });
                }, 800);
            });
        }
    },
    jobs_search_list_preview:function(){
        var $chtml = '';
        for(var $x=0;$x<10;$x++){
            $chtml+= '' +
                '<li class="p-3 mb-2 bg-white rounded preview">' +
                '    <a href="javascript:void(0)">' +
                '        <div class="row">' +
                '            <div class="col-12 text-center text-sm-right">' +
                '                <div class="d-flex clg-rating float-right mt-n3">' +
                '                    <div class="rating-stars mr-2 inline-table">';
            for(var $s = 1; $s<=5; $s++) {
                $chtml+= '' +
                    '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px">' +
                    '   <polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566" fill="#E2E2E9"></polygon>' +
                    '</svg>';
            }
            $chtml+= '' +
                '                    </div>' +
                '                    <div class="rating-count text-center text-muted text-sm-right nurseslounge-home-job-near-me-preload">' +
                '                                                &nbsp;&nbsp;&nbsp;' +
                '                                                &nbsp;&nbsp;&nbsp;' +
                '                    </div>' +
                '                </div>' +
                '            </div>' +
                '            <div class="col-12 align-self-center">' +
                '                <div class="d-flex">' +
                '                    <div class="profile-img mr-3 nurseslounge-home-job-near-me-preload">' +
                '                                                &nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                &nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                &nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                &nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                &nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </div>' +
                '                    <div class="list-info align-self-center w-100">' +
                '                        <h4 class="nurseslounge-home-job-near-me-preload">' +
                '                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                        </h4>' +
                '                        <p class="text-muted nurseslounge-home-job-near-me-preload">' +
                '                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                        </p>' +
                '                    </div>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '    </a>' +
                '</li>';
        }
        return $chtml;
    },
    jobs_near_me_up_validate:function(cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-home-job-near-me .nurseslounge-home-job-near-me-up form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-home-job-near-me .nurseslounge-home-job-near-me-up form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                search: {
                    required: false,
                    maxlength: 255
                },
                employerName: {
                    required: false,
                    maxlength: 255
                },
                distance: {
                    required: true
                },
                listingTypeId:{
                    required: true
                }
            },
            messages: {
                search: {
                    required: "The search field is required",
                    maxlength: "The search field cannot exceed 255 characters"
                },
                employerName: {
                    required: "The employer name field is not required",
                    maxlength: "The employer name cannot exceed 255 characters"
                },
                distance: {
                    required: "The distance field is required"
                },
                listingTypeId:{
                    required: "The listing field is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    add_map_request_current_location:function(cback){
        var $geocoder = new google.maps.Geocoder;
        var $location = {};
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function ($position) {
                $location = {
                    lat: $position.coords.latitude,
                    lng: $position.coords.longitude
                };
                $geocoder.geocode({'location':$location}, function($result, $status) {
                    if ($status === 'OK') {
                        if ($result[0]) {
                            cback($location, $result[0].formatted_address);
                        }else{
                            cback($location, 'The address can to be found');
                        }
                    }else{
                        cback($location, 'Geolocation is not available');
                    }
                });
            }, function ($err) {
                console.log('ERROR(' + $err.code + '): ' + $err.message);
            });
        } else {
            cback($location, 'Geolocation is not available');
        }
    },
    jobs_near_me_request:function($params, cback){
        $.ajax({
            url: "/myDashboard/jobNearMe/mapLocations/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    nurseslounge_myDashboard_jobsNearMe.form_set_values($data.data, function(){
                        cback($data);
                    });
                }
            }
        });
    },
    form_set_values:function($data, cback){
        var $jobs = $("#nurseslounge-home-job-near-me");
        var $jobsForm = $jobs.find(".nurseslounge-home-job-near-me-up form");
        var $jobsDown = $jobs.find(".nurseslounge-home-job-near-me-down");
        $jobsForm.find("input[name='search']").val($data.form.search);
        $jobsForm.find("input[name='employerName']").val($data.form.employer_name);
        $jobsForm.find("select[name='distance']").val($data.form.distance);
        $jobsForm.find("select[name='listingTypeId']").val($data.form.listing_type_id);
        $jobsDown.find(".result-numbers:first").html('<strong>Showing '+$data.total+' </strong>availables<span class="link-color"> Jobs</span>');
        if(cback != undefined){
            cback();
        }
    },
    jobs_near_me_search_map_list:function($params, $map, $data){
        var $mapsMarkers = libs.memoryGet('maps_markers') ? libs.memoryGet('maps_markers') : [];
        $.each($mapsMarkers, function($i, $v){
            $v.setMap(null);
        });
        libs.memorySave('maps_markers', []);
        var $positionSave = [];
        var $bounds = new google.maps.LatLngBounds();
        var $locations = $data && $data.data && $data.data.locations && $data.data.locations ? $data.data.locations : null;
        var $locationsLength = $locations && $locations.length > 0 ? true : false;
        if($locationsLength){
            nurseslounge_jobs.add_map_marker_with_info($map, $locations, $positionSave, true, function(){
                nurseslounge_myDashboard_jobsNearMe.jobs_near_me_pagination($params, $locations, function(){
                    $.each($positionSave, function ($i, $v) {
                        $bounds.extend($v);
                    });
                    $map.fitBounds($bounds);
                    $map.panToBounds($bounds);
                    if($data.data.form.search != '') {
                        $map.setZoom(Math.round(14 - Math.log($data.data.form.distance) / Math.LN2) + 0.7);
                    }
                });
            });
        }else{
            nurseslounge_myDashboard_jobsNearMe.jobs_near_me_pagination($params, $locations, function(){
                nurseslounge_jobs.add_map_request_current_address_location($data.data.form.search, function($location){
                    if($location.lat){
                        $map.setCenter($location);
                        $map.setZoom(Math.round(14-Math.log($data.data.form.distance)/Math.LN2) + 0.7);
                    }
                });
            });
        }
        //$map.addListener("click", function(){});
    },
    jobs_near_me_pagination:function($params, $locations, cback){
        var $reload;
        var $loaded = false;
        var $afterFirstPagination = false;
        var $jobsNearMe = $("#nurseslounge-home-job-near-me");
        var $jobListContainer = $jobsNearMe.find(".nurseslounge-home-job-near-me-down .jobs-list-container");
        var $paginationContainer = $jobsNearMe.find(".nurseslounge-home-job-near-me-down .pagination-nav");
        var $previewHeight = $jobsNearMe.find(".nurseslounge-home-job-near-me-down .jobs-list-container .preview:first").innerHeight();
        var $jobHeight = $jobListContainer.parents(':first').innerHeight();
        var $pageSize = Math.round(($jobHeight/$previewHeight));
        var $paginationObj;
        try{
            $paginationObj = libs.memoryGet('jobs_near_me_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        $paginationObj = $paginationContainer.pagination({
            pageSize: $pageSize > 0 ? $pageSize : 0,
            showPageNumbers: true,
            showPrevious: true,
            showNext: true,
            showNavigator: true,
            showFirstOnEllipsisShow: true,
            showLastOnEllipsisShow: true,
            dataSource:$locations.filter(function($obj){
                return $obj.employer_have_clicks > 0;
            }),
            callback: function($data, $pagination) {
                $loaded = true;
                if($jobListContainer.length > 0 && $jobListContainer.offset().top > 0 && $afterFirstPagination){
                    $('html, body').animate({scrollTop:$jobListContainer.offset().top - 100});
                }else{
                    $afterFirstPagination = true;
                }
                var $chtml = nurseslounge_jobs.add_map_list_html($params, $data);
                if($chtml == ''){
                    $chtml = '' +
                        '<div class="row w-100 m-0 p-0 mt-lg-5">' +
                        '   <h3 class="w-100 text-center">Jobs for this area coming soon.</h3>' +
                        '   <div class="text-center w-100">' +
                        '       <img src="/bimg/NursesLounge/googlePin.png" class="img-fluid of-contain w-120">' +
                        '   </div>' +
                        '</div>';
                }
                libs.checkImageLoad($($chtml).find('img'), function () {
                    $jobListContainer.html('').html($chtml).promise().done(function(){
                        nurseslounge_myDashboard_jobsNearMe.jobs_map_events(function() {});
                    });
                });
            }
        });
        libs.memorySave('jobs_near_me_pagination', $paginationObj);
        $reload = setTimeout(function(){
            if(!$loaded){
                nurseslounge_myDashboard_jobsNearMe.jobs_near_me_pagination($params, $locations, cback);
            }else{
                clearTimeout($reload);
            }
        }, 10000);
        if (cback != undefined) {
            cback();
        }
    },
    jobs_map_events:function(cback){
        var $jobsNearMe = $("#nurseslounge-home-job-near-me");
        var $jobListContainer = $jobsNearMe.find(".nurseslounge-home-job-near-me-down .jobs-list-container");
        var $spu = $jobListContainer.find('.spu');
        var $mapsMarkers = libs.memoryGet('maps_markers');
        var $originalIcon;
        var $originalMarker;
        $spu.unbind();
        $spu.click(function(){
            nurseslounge_jobs.add_map_show_spu($(this).data('key'), $(this).data('facility_key'));
        }).mouseover(function(){
            var $location = $(this).data('location').split(',');
            var $iconUrl = './../../bimg/NursesLounge/onfocus.png';
            $.each($mapsMarkers, function($i, $v){
                var $position = $v.getPosition();
                if(parseFloat($location[0]) == $position.lat() && parseFloat($location[1]) == $position.lng()){
                    $originalMarker = $v;
                    $originalIcon = $originalMarker.getIcon();
                    $originalMarker.setIcon({url:$iconUrl, scaledSize: (new google.maps.Size(20, 35))});
                    return false;
                }
            });
        }).mouseout(function(){
            try{
                $originalMarker.setIcon($originalIcon);
            }catch (e) {

            }
        });
        if(cback != undefined){
            cback();
        }
    },
    //Spotlight
    spotlight_container:function(cback){
        var $container = $("#nurseslounge-home-job-near-me .nurseslounge-home-job-near-me-up .spotlight-wrapper");
        cback($container);
    },
};
